var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHowToIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    baseProfile: "tiny",
    viewBox: "0 0 113.39 113.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M56.74,73.91c-3.03,0-5.5,2.54-5.5,5.66s2.47,5.66,5.5,5.66,5.5-2.54,5.5-5.66-2.47-5.66-5.5-5.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.95,36.52c-1.75-5.63-7.52-10.06-14.01-10.75-5.24-.56-10.12.92-13.75,4.19-3.56,3.19-5.51,7.69-5.51,12.66h8.5c0-2.53.96-4.78,2.69-6.34,1.81-1.63,4.36-2.35,7.16-2.06,3.43.37,6.15,2.74,6.8,4.83,1,3.21-.16,6.37-3.26,8.91-6.02,4.92-9.2,11.57-9.2,19.23v1.17h8.5v-1.17c0-5.09,2.05-9.35,6.08-12.65,5.8-4.74,8.04-11.48,6-18.02Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.68,104.83c-26.54,0-48.14-21.6-48.14-48.14S30.13,8.55,56.68,8.55s48.14,21.6,48.14,48.14-21.6,48.14-48.14,48.14ZM56.68,14.21c-23.42,0-42.48,19.05-42.48,42.48s19.05,42.48,42.48,42.48,42.48-19.05,42.48-42.48S80.1,14.22,56.68,14.22h0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowToIcon);
export default __webpack_public_path__ + "static/media/HowToIcon.e499f6d55d7988b2af4b8f40fa159e0e.svg";
export { ForwardRef as ReactComponent };